// Each segment ends in a divider, so the clear button that closes the row needs none of its own.
export const segmentStyles = 'flex min-w-0 items-center gap-1 border-r border-base px-1.5 py-1 transition-colors'

// The button clips its parts to its rounded corners, so the ring is drawn inside each one.
export const focusStyles = 'outline-ring focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 disabled:cursor-not-allowed'

/** A muted button's filter is on but narrows nothing on the page now, so it reads as secondary. */
export const textColor = (disabled: boolean | undefined, muted?: boolean) => (disabled ? 'text-disabled' : muted ? 'text-muted' : 'text-default')
